import React from 'react';
import { Animated } from 'react-native';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { createStackNavigator } from '@react-navigation/stack';

import DrawerOpen from '@src/components/DrawerOpen';
import HeaderRight from '@src/components/HeaderRight';
import LogoTitle from '@src/components/LogoTitle';
import { i18n } from '@src/i18n';
import HomeScreen from '@src/screens/Home';

import { DashboardHomeStackParamList } from './types';

const Stack = createStackNavigator<DashboardHomeStackParamList>();

const Component: React.FC = () => {
  const theme = useTheme();
  const scrollY = React.useRef(new Animated.Value(0)).current;
  return (
    <Stack.Navigator
      headerMode="screen"
      screenOptions={{
        headerStyle: {
          elevation: scrollY.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 8],
            extrapolate: 'clamp',
          }),
          shadowColor: theme.colors.disabled,
          shadowOffset: {
            height: scrollY.interpolate({
              inputRange: [0, 1],
              outputRange: [-8, 8],
              extrapolate: 'clamp',
            }),
            width: 8,
          },
          shadowRadius: scrollY.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 3],
            extrapolate: 'clamp',
          }),
          shadowOpacity: 0.44,
        },
        title: `${i18n._(t`Home`)} - ${i18n._(t`Youtopin`)}`,
        headerTitle: () => <LogoTitle />,
        headerTitleAlign: 'center',
        // headerRight: () => <HeaderRight />, disable temporary
        headerLeft: () => <DrawerOpen />,
      }}
    >
      <Stack.Screen name="Home" component={HomeScreen} />
    </Stack.Navigator>
  );
};

Component.displayName = 'DashboardHomeStack';

export default Component;
